module.exports = __webpack_public_path__ + "img/brush/brush.png";


//////////////////
// WEBPACK FOOTER
// ./img/brush/brush.png
// module id = 60
// module chunks = 3